<template>
	<div class="pages" :style="{ height: height + 'px' }">
		<div class="box" :style="{ height: height + 'px' }">
			<div class="left"></div>
			<div class="right">
				<p class="title">Forgot your password</p>
				<li class="li">
					<input
						type="text"
						v-model="mailbox"
						placeholder="Please enter your email address"
					/>
				</li>
				<li class="li">
					<select @change="selectcity($event)">
						<option v-for="(item, index) in prefixList" :key="index">
							{{ item.name }}
						</option>
					</select>
					<input
						type="text"
						v-model="phone"
						maxlength="11"
						@input="phone = phone.replace(/[^\d]/g, '')"
						placeholder="Please enter your mobile phone number"
					/>
				</li>
				<li class="li">
					<input
						type="text"
						v-model="code"
						placeholder="Please enter the verification code"
						maxlength="6"
						@input="code = code.replace(/[^\d]/g, '')"
					/>
					<span v-if="yzmbotshou" @click="getyzm">Get verification code</span>
					<span v-if="yzmbothide">{{ times }}s post acquisition</span>
				</li>
				<li class="li">
					<input
						type="password"
						v-model="password"
						placeholder="Please enter a new password"
					/>
				</li>
				<li class="li">
					<input
						type="password"
						v-model="dbpassword"
						placeholder="Please enter the new password again"
					/>
				</li>
				<p class="btn" @click="subimt">preservation</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'forget',
	data() {
		return {
			height: '',
			mailbox: '',
			phone: '',
			code: '',
			password: '',
			dbpassword: '',
			times: 60,
			yzmbotshou: true,
			yzmbothide: false,
			prefixList: [],
			prefix: ''
		};
	},
	created() {
		this.height = window.innerHeight;
		this.getPrefix();
	},
	methods: {
		// 手机号前缀
		selectcity() {
			this.prefix = e.target.value;
		},
		// 获取手机号前缀
		getPrefix() {
			this.$api.prefix({}).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.prefixList = res.dataList;
					this.prefix = res.dataList[0].name;
				}
			});
		},
		// 获取验证码
		getyzm() {
			var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
			if (!myreg.test(this.phone)) {
				this.$message({
					message: 'Mobile phone number input error!',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			let data = {
				prefix: this.prefix,
				phone: this.phone
			};
			this.$api.code(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.getcode();
				} else {
					this.$message({
						message: res.resultNote,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			});
		},
		// 获取验证码倒计时
		getcode() {
			var num = 60;
			this.yzmbotshou = false;
			this.yzmbothide = true;
			var interval = setInterval(() => {
				--this.times;
			}, 1000);
			setTimeout(() => {
				clearInterval(interval);
				this.yzmbotshou = true;
				this.yzmbothide = false;
				this.times = num;
			}, 60000);
		},
		// 保存
		subimt() {
			if (this.mailbox == '') {
				this.$message({
					message: 'Please fill in the email',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.code == '') {
				this.$message({
					message: 'Please enter the verification code',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.password.length < 6) {
				this.$message({
					message: 'The password must be at least six digits',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.password !== this.dbpassword) {
				this.$message({
					message: 'Inconsistent password input',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			let data = {
				mail: this.mailbox,
				phone: this.phone,
				code: this.code,
				password: this.$md5(this.dbpassword)
			};
			this.$api.changePassword(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					let that = this;
					that.$message({
						message: '重置成功',
						type: 'success',
						center: true,
						duration: 1000,
						onClose: function() {
							that.$router.push({ path: '/' });
						}
					});
				} else {
					this.$message({
						message: res.resultNote,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #000;
	.box {
		display: flex;
		align-items: center;
		.left {
			width: 60%;
			height: 100%;
			background-image: url(../../assets/bg.png);
			background-size: cover;
		}
		.right {
			width: 600px;
			height: 750px;
			background-image: url('../../assets/forget.png');
			background-size: 100% 100%;
			padding: 120px 40px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			.title {
				font-size: 26px;
				font-family: PingFang SC;
				font-weight: 500;
				color: #13fffc;
			}
			.li {
				width: 100%;
				height: 80px;
				border-bottom: 1px solid rgba(19, 255, 252, 0.3);
				box-sizing: border-box;
				display: flex;
				align-items: center;
				select {
					background: #060a14;
					border: none;
					color: #13fffc;
					outline: none;
					margin-right: 20px;
					font-size: 18px;
					option {
						background: #000;
						color: #00d9dd;
						font-size: 18px;
					}
				}
				input {
					flex: 1;
					height: 79px;
					background: #060c18;
					border: none;
					font-size: 18px;
					outline: none;
					color: #13fffc;
					padding: 0 10px 0 0;
					box-sizing: border-box;
				}
				span {
					display: block;
					width: 180px;
					font-size: 18px;
					color: #00fff9;
					text-align: right;
				}
			}
			.btn {
				width: 100%;
				height: 60px;
				background: linear-gradient(90deg, #1dafaa 0%, #23fef6 100%);
				font-size: 20px;
				font-family: PingFang SC;
				font-weight: 500;
				color: #f6f6f6;
				line-height: 60px;
				text-align: center;
			}
		}
	}
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
input[type='number'] {
	-moz-appearance: textfield;
}
</style>
>
